import React from 'react'
import i18 from '../../../../i18'

class ListRowUnprocessedInvoiceRule extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            invoice: props.invoice,
            invoiceItem: props.invoiceItem,
            vatCollectorCodes: props.vatCollectorCodes,
            name: props.invoiceItem.name,
            nameEnabled: false,
            invoiceNumber: props.invoice.invoiceNumber,
            invoiceNumberEnabled: false,
            vat: props.invoiceItem.vat,
            company_type: props.invoice.company_type,
            vat_code: '',
            collector_code_fk_id: '',
            main_bookkeeping_number: '',
        }

        this.main_bookkeeping_number = React.createRef();
        this.collector_code_fk_id = React.createRef();
        this.vat_code = React.createRef();
    }

    onElementChange = (event) => {
        // todo: check
        this.setState({
            [event.target.attributes.name.nodeValue]: event.target.value,
        })
    }

    onKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.createRule('final');
        }
    }

    ruleValidation = () => {
        if(!this.state.nameEnabled && !this.state.invoiceNumberEnabled){
            this.props._addNotification('Vagy a forgalom típusát vagy a számlaszámot engedélyezni kell!', 'error', 30);
            this.main_bookkeeping_number.current.focus();
            return false;
        }


        if (!this.state.main_bookkeeping_number) {
            this.props._addNotification('Kérünk töltse ki a [Főkönyv szám] mezőt!', 'error', 30);
            this.main_bookkeeping_number.current.focus();
            return false;
        }

        if (!this.state.collector_code_fk_id) {
            this.props._addNotification('Kérünk töltse ki a [Gyűjtő kód] mezőt!', 'error', 30);
            this.collector_code_fk_id.current.focus();
            return false;
        }

        if (this.state.collector_code_fk_id !== 3 && !this.state.vat_code) {
            this.props._addNotification('Kérünk töltse ki a [ÁFA Főkönyv szám] mezőt!', 'error', 30);
            this.vat_code.current.focus();
            return false;
        }

        return true;
    }

    createRule = (type) => {
        if (!this.ruleValidation()) {
            return;
        }
        this.props.createRule({
            item_name: this.state.nameEnabled ? this.state.name : '',
            invoice_number: this.state.invoiceNumberEnabled ? this.state.invoiceNumber : '',
            vat: this.state.vat,
            company_type: this.state.company_type,
            type: type,

            main_bookkeeping_number: this.state.main_bookkeeping_number,
            collector_code_fk_id: this.state.collector_code_fk_id,
            vat_degree: this.state.collector_code_fk_id === 3 ? '' : this.state.vat_code,
        });

        this.setState({
            main_bookkeeping_number: '',
            collector_code_fk_id: '',
            vat_code: '',
        });
        this.main_bookkeeping_number.current.focus();
    }

    render() {
        let name_checkbox_id = Math.random(9999, 99999);
        let invoice_number_checkbox_id = Math.random(9999, 99999);

        return (
            <tr>
                <td>
                    <input
                        id={name_checkbox_id}
                        name='nameEnabled'
                        value={this.state.nameEnabled}
                        type="checkbox"
                        onChange={(event) => this.onElementChange(event)}
                    />
                    <input
                        name='name'
                        value={this.state.name}
                        className='no-border-underline-text-input'
                        type='text'
                        onChange={(event) => this.onElementChange(event)}
                        onKeyDown={(event) => this.onKeyDown(event)}
                    />
                </td>
                <td>
                    <input
                        name='main_bookkeeping_number'
                        value={this.state.main_bookkeeping_number}
                        ref={this.main_bookkeeping_number}
                        className='bordered-input'
                        type='text'
                        onChange={(event) => this.onElementChange(event)}
                        onKeyDown={(event) => this.onKeyDown(event)}
                    />
                </td>
                <td>{parseInt(this.state.invoiceItem.vat, 0)}%</td>
                <td>
                    <select
                        name='collector_code_fk_id'
                        value={this.state.collector_code_fk_id}
                        ref={this.collector_code_fk_id}
                        className='minimal form-control'
                        onChange={(event) => this.onElementChange(event)}
                        onKeyDown={(event) => this.onKeyDown(event)}
                    >
                        <option value='' key='0'>Kérjük válasszon</option>
                        {this.state.vatCollectorCodes.map((el) => {
                            return <option value={el.id} key={el.id}>{el.code}&nbsp;({el.title})</option>
                        })}
                    </select>
                </td>
                <td>{this.state.invoice.tax_number}</td>
                <td>{this.state.invoice.city}</td>
                <td>{this.state.invoice.company_name}</td>
                <td>{this.state.invoice.paymentMethodLabel}</td>
                <td>
                    <input
                        id={invoice_number_checkbox_id}
                        name='invoiceNumberEnabled'
                        value={this.state.nameEnabled}
                        type="checkbox"
                        onChange={(event) => this.onElementChange(event)}
                    />
                    <input
                        name='invoiceNumber'
                        value={this.state.invoiceNumber || ""}
                        className='no-border-underline-text-input'
                        type='text'
                        onChange={(event) => this.onElementChange(event)}
                        onKeyDown={(event) => this.onKeyDown(event)}
                    />
                </td>
                <td>
                    <input
                        name='vat_code'
                        value={this.state.vat_code}
                        ref={this.vat_code}
                        className='bordered-input'
                        type='text'
                        onKeyDown={(event) => this.onKeyDown(event)}
                        onChange={(event) => this.onElementChange(event)}
                        disabled={this.state.collector_code_fk_id === 3}
                    />
                </td>
                <td>
                    <i
                        onClick={(event) => this.createRule('final')}
                        title={i18.CUSTOMER._createRulesAndProcess}
                        className='fa fa-dot-circle-o'
                        aria-hidden='true'/> &nbsp;&nbsp;
                    <i
                        onClick={(event) => this.createRule('temporarily')}
                        title={i18.CUSTOMER._oneTimeProcessing}
                        className='fa fa-check-circle'
                        aria-hidden='true'/>
                </td>
            </tr>
        )
    }
}

export default ListRowUnprocessedInvoiceRule


// WEBPACK FOOTER //
// ./src/components/customer/steps/assignment/ListRowUnprocessedInvoiceRule.js